import update from 'immutability-helper';
import { createReducer } from 'redux-create-reducer';
import actionsAndConstants from '../../shared/actionsAndConstants';

const {
  dashboard: { constants: dashboardConstants },
  dashboardMassUpload: { constants: dashboardMassUploadConstants },
  topNavbar: { constants: topNavbarConstants }
} = actionsAndConstants;

const initialState = {
  massUpload: {
    exportingTemplate: false,
    uploadError: ''
  },
  stats: {
    data: {
      inventoryByDepot: [],
      remainingDays: [],
      totalInventory: null
    },
    error: false,
    loading: false
  }
};

const exportMassUploadTemplate = state => (
  update(state, {
    massUpload: { exportingTemplate: { $set: true } }
  })
);

const exportMassUploadTemplateFailedOrSucceeded = state => (
  update(state, {
    massUpload: { exportingTemplate: { $set: false } }
  })
);

const importMassUploadFile = state => (
  update(state, { massUpload: { uploadError: { $set: '' } } })
);

const importMassUploadFileFailed = (state, { meta: { alert: { message = '' } = {} } = {} }) => (
  update(state, { massUpload: { uploadError: { $set: message } } })
);

const loadStats = state => (
  update(state, {
    stats: {
      $merge: {
        error: false,
        loading: true
      }
    }
  })
);

const loadStatsFailed = state => (
  update(state, {
    stats: {
      $merge: {
        error: true,
        loading: false
      }
    }
  })
);

const loadStatsSucceeded = (state, { payload: data }) => (
  update(state, {
    stats: {
      data: { $merge: data },
      error: { $set: false },
      loading: { $set: false }
    }
  })
);

const logoutSucceeded = () => initialState;

const dashboardReducer = createReducer(initialState, {
  [dashboardConstants.loadStats]: loadStats,
  [dashboardConstants.loadStatsFailed]: loadStatsFailed,
  [dashboardConstants.loadStatsSucceeded]: loadStatsSucceeded,
  [dashboardMassUploadConstants.exportTemplate]: exportMassUploadTemplate,
  [dashboardMassUploadConstants.exportTemplateFailed]: exportMassUploadTemplateFailedOrSucceeded,
  [dashboardMassUploadConstants.exportTemplateSucceeded]: exportMassUploadTemplateFailedOrSucceeded,
  [dashboardMassUploadConstants.uploadFile]: importMassUploadFile,
  [dashboardMassUploadConstants.uploadFileFailed]: importMassUploadFileFailed,
  [topNavbarConstants.logoutSucceeded]: logoutSucceeded
});

export default dashboardReducer;



// WEBPACK FOOTER //
// ./src/containers/Dashboard/reducer.js